<template>
  <header class="header-claro">
    <div
      class="home-button"
      name="homeButton"
      @click="goHome"
      @keydown.delete="goHome"
    >
      <house-fill
        color="white"
        size="30"
        data-testid="home-button"
      />
    </div>
    <div
      class="logo"
      @click="goHome"
      @keydown.delete="goHome"
    >
      <htech-img
        src="img/claro_logo-white.png"
        alt="claro logo"
        name="claro home"
        data-testid="claro-logo"
        layout="fill"
        object-fit="contain"
      />
    </div>
  </header>
</template>

<script>
import { HouseFill } from '@/components/icons';

export default {
  name: 'Header',
  components: { HouseFill },
  methods: {
    goHome() {
      if (this.$route.name === 'SetNumber') {
        const url = `https://paquetes.miclaro.${this.$store.isCR()
          ? '' : 'com.'}${this.$store.state.country.pais.toLowerCase()}`;

        window.location.href = url;
      } else this.$router.push({ name: 'SetNumber' });
    }
  }
};
</script>

<style lang="scss" scoped>
  .header-claro {
    width: 100%;
    color: get-color('clear');
    background-color: get-color('primary');
    font-size: 30px;
    font-weight: bold;
    padding-top:5px;
    padding-bottom: 5px;
    padding-inline: 1rem;
    margin:0;
    img {
      width: 64px;
    }
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-auto-flow: column;
    justify-items: stretch;
    align-items: center;
  }

  .logo{
    justify-self: center;
    cursor: pointer;
    width: 64px;
    height: 45px;
    position: relative;
  }

  .home-button {
    justify-self: start;
    display: flex;
    justify-content: center;
    cursor: pointer;
  }
</style>
